import React, { useEffect } from 'react';
import { Translation } from 'react-i18next';
import { Form, Select } from 'antd';

const ModuleSerieInput = ({
  name,
  disabled = false,
  partnershipId,
  load,
  options,
  placeholder,
  label = null,
  rules = [],
  ...props
}) => {
  // load tags on mount
  useEffect(() => {
    if (partnershipId) {
      load(partnershipId);
    }
  }, [load, partnershipId]);

  return (
    <Translation>
      {(t) => (
        <div className='form-group'>
          {label && (
            <div className='ant-col ant-col-24 ant-form-item-label'>
              <label className='ant-form-item-required'>{t(label)}</label>
            </div>
          )}

          <Form.Item name={name || 'module_serie_id'} rules={rules}>
            <Select
              showSearch
              disabled={props.isLoading || props.isSubmitting}
              loading={props.isLoading}
              style={{ width: '100%' }}
              placeholder={
                placeholder ||
                t('learning_admin_form_input_placeholder_module_serie')
              }
            >
              {options.map((x) => (
                <Select.Option key={x.id} value={x.id}>
                  {x.title}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
        </div>
      )}
    </Translation>
  );
};

export default ModuleSerieInput;
